import { render, staticRenderFns } from "./EditReservation.vue?vue&type=template&id=0315f07f&"
import script from "./EditReservation.vue?vue&type=script&lang=js&"
export * from "./EditReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports